import type { ChannelSummary } from '@pulsify/shared'
import type { FlyerLocale } from '~/features/events/checkin-flyer/flyer-content'
import * as m from '~/paraglide/messages'

export interface FollowFlyerContent {
  name: string
  avatarUrl: string | null
  initial: string
  headline: string
  tagline: string
  fineprint: string
  url: string
}

/** The printed sheet that asks passers-by to follow an organizer page. */
export function buildFollowFlyerContent(
  organizer: Pick<ChannelSummary, 'name' | 'avatarUrl'>,
  url: string,
  locale: FlyerLocale,
): FollowFlyerContent {
  const options = { locale }
  const name = organizer.name.trim()
  return {
    name,
    avatarUrl: organizer.avatarUrl,
    initial: name.slice(0, 1).toUpperCase(),
    headline: m.organizerFollowFlyerHeadline({ name }, options),
    tagline: m.organizerFollowFlyerTagline({}, options),
    fineprint: m.organizerFollowFlyerFineprint({}, options),
    url,
  }
}

/** The link printed in the QR code: the counted `qr` share link, else the plain page. */
export function followQrUrl(qrShareUrl: string | null, webBase: string, handle: string): string {
  return qrShareUrl ?? `${webBase.replace(/\/$/, '')}/o/${handle}`
}
